// branchAgentService.js
import { getBranches } from '@/api/locations/branches';
import { getAgents, getAgentsBranchWise } from '@/api/agents';
import { AdminModule } from '@/store/modules/admin';
import { getQuery } from '@/utils';
import { isAdmin, isSuperAdmin } from '@/common';
export const BranchAgentService = {
  async fetchBranches(branchIds = undefined) {
    //  return if branchIds is empty or undefined
    if (Array.isArray(branchIds) && branchIds.length === 0) {
      return []; // Return an empty array or handle as needed
    }
    const query = {
      enabled: true,
      sort: 'name,ASC'
    };
    if (!isSuperAdmin() || !isAdmin()) {
      // Convert array to comma-separated values before passing to getQuery
      query.id = branchIds.length > 1 ? branchIds.join(',') : branchIds;
      query.filter = {
        enabled: 'eq',
        id: '$in'
      };
    }
    return await getBranches(getQuery(query));
  },
  async fetchAgents(branchIds = undefined) {
    if (branchIds === null) {
      return;
    }
    const arrayOfBranchId = Array.isArray(branchIds) ? branchIds : [branchIds];
    try {
      const query = {
        enabled: true,
        sort: 'name,ASC',
        applyBranchIdFilter: true,
        filter: {
          enabled: 'eq'
        }
      };
      if ((!isSuperAdmin() || !isAdmin()) && arrayOfBranchId.length > 0) {
        return await getAgentsBranchWise(getQuery(query));
      } else {
        return await getAgents(getQuery(query));
      }
    } catch (error) {
      // Handle error
    }
  },
  assignBranchId() {
    var _loggedInAdminDetails, _loggedInAdminDetails2;
    const loggedInAdminDetails = AdminModule;
    let branchId = null;
    if (((_loggedInAdminDetails = loggedInAdminDetails.branchIds) === null || _loggedInAdminDetails === void 0 ? void 0 : _loggedInAdminDetails.length) === 1) {
      branchId = loggedInAdminDetails.branchIds[0];
    } else if (((_loggedInAdminDetails2 = loggedInAdminDetails.branchIds) === null || _loggedInAdminDetails2 === void 0 ? void 0 : _loggedInAdminDetails2.length) > 1) {
      branchId = loggedInAdminDetails.branchIds;
    }
    return branchId;
  }
};